import React from "react";
import { NavLink } from "react-router-dom";
import Logo from "../assets/logo.png"

export default function Footer() {
  return (
    <footer
      className="w-full pt-5 pb-3 mt-5"
      style={{
        background: "linear-gradient(90deg,#2e3d9c 0%,#224eae 50%,#3a79e0 100%)",
        color: "#f5f7fa",
        fontFamily: "Inter, sans-serif",
        letterSpacing: 0.1,
        position: "relative",
        zIndex: 1,
        overflow: "hidden",
      }}
    >
      <div className="container">
        <div className="row gy-5">
          <div className="col-md-3">
            <div className="mb-3 d-flex align-items-center gap-2">
              <img
                src={Logo}
                alt="Nexen Logo"
                className="footer-logo"
                style={{
                  width: "120px",
                  height: "auto",
                  maxWidth: "100%",
                  objectFit: "contain"
                }}
              />
              {/* <span className="fw-bold h5 mb-0" style={{ color: "#FFF" }}>
                NEXEN CONSULTING
              </span> */}
            </div>
            <div style={{ fontSize: 15, color: "#cddbfa" }} className="mb-3">
              Nexen Consulting are primarily categorized into Consulting Services and Tax Filing Services.
            </div>
          </div>

          {/* Other columns remain same */}
          <div className="col-md-2">
            <h6 className="fw-semibold mb-2" style={{ color: "#ffffff" }}>
              Contact
            </h6>
            <div className="mb-1">
              <b style={{ color: "#fff" }}>Nexen Consulting</b>
            </div>
            <div style={{ fontSize: 15 }}>
              DALLAS, GA, 30132, USA.
              <br />
              <a
                href="mailto:info@nexenconsults.com"
                className="text-light text-decoration-underline"
              >
                info@nexenconsults.com
              </a>
              <br />
              <a href="tel:+919966969809" className="text-light text-decoration-underline">
                +91 996 696 9809
              </a>
              <br />
              <a href="tel:+19436789878" className="text-light text-decoration-underline">
                +1 (943) 678 9878
              </a>
            </div>
          </div>

          <div className="col-md-2">
            <h6 className="fw-semibold mb-2" style={{ color: "#ffffff" }}>
              Quick Links
            </h6>
            <ul className="list-unstyled mb-0" style={{ fontSize: 15 }}>
              <li>
                <NavLink to="/about" className="text-decoration-none text-light">
                  About Us
                </NavLink>
              </li>
              <li>
                <NavLink to="/services/business-consulting" className="text-decoration-none text-light">
                  Consulting
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact" className="text-decoration-none text-light">
                  Contact us
                </NavLink>
              </li>
            </ul>
          </div>

          <div className="col-md-2">
            <h6 className="fw-semibold mb-2" style={{ color: "#ffffff" }}>
              Legal
            </h6>
            <ul className="list-unstyled mb-0" style={{ fontSize: 15 }}>
              <li>
                <NavLink to="/privacy-policy" className="text-decoration-none text-light">
                  Privacy Policy
                </NavLink>
              </li>
              <li>
                <NavLink to="/terms-and-conditions" className="text-decoration-none text-light">
                  Terms & Conditions
                </NavLink>
              </li>
            </ul>
          </div>

          <div className="col-md-3">
            <h6 className="fw-semibold mb-2" style={{ color: "#ffffff" }}>
              Office Hours
            </h6>
            <div style={{ fontSize: 15 }}>
              Monday – Saturday
              <br />
              24/7 Support, PST
              <br />
              Sunday: By Appointment
            </div>
          </div>
        </div>

        <hr className="my-4" style={{ borderColor: "#436ef0" }} />

        <div
          className="d-flex flex-column flex-md-row justify-content-between align-items-center small"
          style={{ color: "#b7cefb" }}
        >
          <div>
            Copyright 2024 &copy;{" "}
            <b style={{ color: "#fff" }}>
              Nexen Consults LLC.
            </b>{" "}
            All Rights Reserved.
          </div>
          <div className="mt-3 mt-md-0 d-flex align-items-center gap-3">
            <a
              href="https://www.facebook.com/share/182mT8osda/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-light fs-4"
            >
              <i className="bi bi-facebook"></i>
            </a>

            <a
              href="https://www.linkedin.com/company/nexen-consulting/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-light fs-4"
            >
              <i className="bi bi-linkedin"></i>
            </a>

            <a
              href="https://www.instagram.com/nexen_consulting?igsh=cjNsZWZ5OXIweHVr&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-light fs-4"
            >
              <i className="bi bi-instagram"></i>
            </a>

            <a
              href="https://wa.me/919966969809"
              target="_blank"
              rel="noopener noreferrer"
              className="text-light fs-4"
            >
              <i className="bi bi-whatsapp"></i>
            </a>
          </div>
        </div>
      </div>

      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css"
      />
    </footer>
  );
}
